import {LinePlotDisplayRowFnType} from '../types';
import {LinePlotTemplateSettings} from '../workspaceTemplatesQueries';
import {getGroupSettingDisplayRow} from './groupingDisplayValues';
import {
  getSmoothingTypeDisplayRow,
  getSmoothingWeightDisplayRow,
} from './smoothingDisplayValues';
import {getXAxisDisplayRow} from './xAxisDisplayValues';

export const LINE_PLOT_TEMPLATE_DISPLAY_FNS: Record<
  keyof LinePlotTemplateSettings,
  LinePlotDisplayRowFnType
> = {
  smoothingType: getSmoothingTypeDisplayRow,
  smoothingWeight: getSmoothingWeightDisplayRow,
  useRunsTableGroupingInPanels: getGroupSettingDisplayRow,
  xAxis: getXAxisDisplayRow,
};
